import { useTheme } from '@mui/material/styles';

import { useMatchQuery } from './useMatchQuery';

/**
 * Пользовательский хук, который определяет, является ли текущий размер экрана большим настольным.
 *
 * @returns Возвращает true, если размер экрана 'lg' или больше, иначе false.
 */
export const useIsDesktopLarge = () => {
  const theme = useTheme();

  return useMatchQuery(theme.breakpoints.up('lg'));
};
